module.exports = __webpack_public_path__ + "img/map.1291dbf1.svg";